import { Stack } from '@mui/material';
import { TimelineNode } from './interfaces';
import { getTimelineNodeKey } from './utils.timeline';
import { AgentProgressTimelineBlock } from './TimelineBlock';

export function AgentProgressTimeline({ nodes }: { nodes: TimelineNode[] }) {
  return (
    <Stack spacing={1.5}>
      {nodes.map((node) => (
        <AgentProgressTimelineBlock key={getTimelineNodeKey(node)} node={node} />
      ))}
    </Stack>
  );
}
